export const SDK_VERSION = '8.28.0';
